import SyntaxHighlighter from 'react-syntax-highlighter';
import { a11yDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
const CodeSocal = () => {


const code2 = `
   fileFunctionObj.clearFile(FILENAME)
        currentMessage = fileFunctionObj.normalize_content(cleanMessageArray)
        msg = currentMessage[0]
        checkMsg = fileFunctionObj.normalize_content(fileFunctionObj.readFile(FILENAME))
        fileFunctionObj.writeFile(FILENAME, cleanMessageArray[0])
        matchFound =  fileFunctionObj.match_phrase(checkMsgLower)

        #    matches if message has the word reminder in it.
        if matchFound:
            print("Reminder/Not a new event found in text!")
            print(f"No new messages. Continuing with the program")
            timeRan = timeFunction()
            await asyncio.sleep(30)
            continue
        
        eventArrDescriptions = googleObj.getGoogleCalendarEvents(google_calendar_token_file,google_drive_service_file_path,SCOPES)
        print("Jacard Check")
        newDsc = desc + furryUsPrompt
        jacardCheck = False
        jacardCheck = fileFunctionObj.jacardCheck(eventArrDescriptions,newDsc)

        if jacardCheck:
            print("we found a dupliate")
            # checkJaccard = True
            await asyncio.sleep(60)
            continue
        
        print("new message")
        fileFunctionObj.clearFile(FILENAME)
        fileFunctionObj.writeFile(FILENAME, cleanMessageArray[0])


`
  const code1 = `
    while True:

        googleObj = Google()
        googleAiObj = GoogleGeminiAi()
        fileFunctionObj = FileFunctions()
        
        channel = "https://t.me/SoCalFursCalendar"
        
        cleanMessageArray = await messageKeyScrapper(channel, limit = 10)

        await asyncio.sleep(3) 
        
        currentMessage = fileFunctionObj.normalize_content(cleanMessageArray)
        msg = currentMessage[0]
        checkMsg = fileFunctionObj.normalize_content(fileFunctionObj.readFile(FILENAME))

        await asyncio.sleep(3)

        checkMsgLower = checkMsg.lower()
        desc = checkMsgLower

        transform = currentMessage.lower()

        check = True
    
        if check:
            testCount+= 1
            print(testCount)

        if checkMsgLower == transform:
            print(f"No new messages. Continuing with the program")
            timeRan = timeFunction()
            await asyncio.sleep(60 * 3)
            continue
     `
  
const code3 = `

        print("new message")
        fileFunctionObj.clearFile(FILENAME)
        fileFunctionObj.writeFile(FILENAME, cleanMessageArray[0])

        #Get photo of event and path:
        photoFilePath = await scrapePhotos(channel,limit = 1)
        await asyncio.sleep(3) 
        await asyncio.sleep(3)
        flag = True
     

        while flag:
            structuredEventDict = googleAiObj.testAi(cleanMessageArray,google_gemini_api_key)
            
             #Check the photofile path if its empty or not
            if structuredEventDict == " ":
                print("Ai could not process the message. event refresh")
                break

            afterAi = googleAiObj.transformStruct(msg,structuredEventDict, cleanMessageArray,google_gemini_api_key)

            if afterAi == " ":
                print("AI could not process message part two")
                break
            
            if googleObj.checkNameDupilicate(afterAi,google_calendar_token_file,google_drive_service_file_path,SCOPES):
                print("We have found a duplicate event from our checkNameDuplicateFunction.")
                break

            if photoFilePath:
                    photoFile = photoFilePath[0]
                    googleObj.uploadToGoogleDrive(photoFilePath,structuredEventDict,google_drive_service_file_path,google_drive_folder_id)
                    drivePhotoArr = googleObj.getGoogleDriveLink(google_drive_service_file_path)
                    googleObj.toGoogleCalendar(afterAi,drivePhotoArr,google_calendar_token_file,google_drive_service_file_path,countVar)
                    os.remove(photoFile)
                    photoFilePath = []
                    break
            else:
                     drivePhotoArr = []
                     print("Error: photoFilePath is empty.")
                     structuredEventDict = googleAiObj.testAi(cleanMessageArray,google_gemini_api_key)
                     afterAi = googleAiObj.transformStruct(msg,structuredEventDict, cleanMessageArray,google_gemini_api_key)
                     googleObj.toGoogleCalendar(afterAi,drivePhotoArr,google_calendar_token_file,google_drive_service_file_path,countVar)
                     break
`

  const quick= `
    "start": {{
       "dateTime": "2025-09-26"
     }},
     "end": {{
       "dateTime": "2025-09-27"
     }}`
  return (
    <div>       
         <p style={{color:"green",color:"green",fontSize:"18px",textDecoration:"None"}}>
                Summary:
             </p>
             
             <p style={{fontSize:"18px",textDecoration:"None"}}>

            I have this script on a VPS server, and it checks the current message in Telegram
            against the message in the text file every 3 minutes. Three minutes was the optimized time
            that I could use the Telethon API without causing rate limits.
            It checks the last message that was from the Telegram channel. Therefore, if there is a new event
            and the 3-minute timer ends, the script will check whether the messages are equal or not.
            If they are equal, do not continue the program and wait another 3 minutes.
            If they are not, continue through the other checks and at the end
            add the event to the calendar, refresh the text file with the new message, and
            continue to check. Now it would be the same message, so we wait another 3 minutes.
                 </p>
                               <p style={{color:"green",fontSize:"18px",textDecoration:"None"}}>
                Function: messageKeyScrapper
             </p>
                          <p style={{fontSize:"18px",textDecoration:"None"}}>

             This part: I'm reading the message from Telegram
            using Telegram’s API called Telethon. I made a function called messageKeyScrapper that basically
            just returns one single message and returns that message in an array. I definitely could have just used
            a different variable instead of an array, but this is what I started with in the beginning.
            I set a message in a text file to serve as the last message saved. It would have been the
            last message in the Telegram channel.
                 </p>
                   <p style={{color:"green",fontSize:"18px",textDecoration:"None"}}>
                Function: fileFunctionObj
             </p>

              <p style={{fontSize:"18px",textDecoration:"None"}}>

     For this function, all I'm doing is formatting the current message in a way that can
    be compared with the message that was stored. This is to prevent running the main chunk of
    the program unnecessarily and to avoid duplicate messages. This is one of the functions that prevents duplication.
                 </p>
             
         <div style={{fontSize:"16px"}}>
            
    <SyntaxHighlighter language="python" style={a11yDark}>
      {code1}
    </SyntaxHighlighter>
        </div>
        <div>
             <p style={{color:"green",fontSize:20,textDecoration:"None"}}>
                Function: MatchFound
             </p>
                 <p style={{fontSize:20,textDecoration:"None"}}>

               This function checks if the message contains “reminder,” “today,” “this week,”
            etc. It checks messages that have words like these. The point is that
            usually event organizers post their events in advance and events are
            not impromptu. However, organizers do post reminder messages that can
            contain some of these words. If the event message has any of these words,
            then we simply loop again for another 3 minutes. If there is no match found,
            we continue to the next function, jacardCheck.
                 </p>
                   <p style={{color:"green",fontSize:"18px",textDecoration:"None"}}>
                Function: jacardCheck
             </p>

              <p style={{fontSize:"18px",textDecoration:"None"}}>
                                This function grabs all the event descriptions from the Google Calendar and uses
                                a Jaccard similarity algorithm to check if the message we are checking (to see if it’s a reminder)
                                is already on the Google Calendar. The Jaccard function compares the two sentences and
                                says that if the messages are over 80% similar, then we have a duplicate event. If not,
                                we continue to add it to the Google Calendar.
                 </p>
      
       <div style={{fontSize:"16px"}}>
                          <SyntaxHighlighter language="python" style={a11yDark}>
      {code2}
    </SyntaxHighlighter>
       </div>
  


             <p style={{color:"green",fontSize:"18px",textDecoration:"None"}}>
                Function: StructuredEventDict
             </p>
                 <p style={{fontSize:"18px",textDecoration:"None"}}>
             StructuredEventDict takes the new event message that we filtered out
            through the checks. Then we have AI parse the details through
            this function to get the name, location, time, and date.
                 </p>
                   <p style={{color:"green",fontSize:"18px",textDecoration:"None"}}>
                Function: afterAi
             </p>

              <p style={{fontSize:"18px",textDecoration:"None"}}>
                AfterAi google gemini reads the date and formats it to google calendar standards which looks something
                like this.
            
                </p>
                  <div style={{fontSize:"16px"}}>
                                        <SyntaxHighlighter language='json' style={a11yDark}>
            {quick}
        </SyntaxHighlighter>
                  </div>

                     <p style={{fontSize:"18px",textDecoration:"None"}}>
                The AI formats the date of its previous message. Since the AI can interpret the message
                differently sometimes due to the version of the AI I'm using, which is the free version,
                that is why I use it twice, since it’s not always perfect. By using two AI requests, it is able to perform
                with no problems.
            
                </p>
                          <p style={{fontSize:"18px",textDecoration:"None"}}>
               When we run the Google Gemini requests for the AI, I also add try-catch blocks to catch any errors
                from the AI. If the AI either could not process every detail of the event, if details are null, etc.,
                that’s why we have if structuredEventDict == " ": — these are checks within the function
                that verify whether the AI processed the prompt correctly.
            
                </p>
                    <p style={{color:"green",fontSize:"18px",textDecoration:"None"}}>
                Function: checkNameDupilicate

             </p>
                   <p style={{fontSize:"18px",textDecoration:"None"}}>
         checkNameDuplicate does a similar check of the description; however, I noticed that
        the AI is usually pretty consistent in naming events the same. So, I added functionality
        to check if adding an event the AI check has the same name as the date that we are
        checking on the Google Calendar. This is another way to get rid of any duplicates.
            
                </p>
             
               <div style={{fontSize:"16px"}}>
            <SyntaxHighlighter language="python" style={a11yDark}>
      {code3}
    </SyntaxHighlighter>
               </div>
  
        <p style={{color:"green",fontSize:"18px",textDecoration:"None"}}>
                End Of Code: if photoFilePath

             </p>
                <p style={{fontSize:"18px",textDecoration:"None"}}>
                After we go through all the previous code above, we go into one of the two functions.
                If photoFilePath is true, that means we extracted a photo and will also upload it
                to Google Drive and also upload it as an attachment to the Google Calendar event.
                If it’s not, then we do not have an image, so we skip that part and still add the event.
                Then loop through the while loop to check if we have a new message or not.

                </p>
                
             

    
    </div>
       
    </div>
   

  );
};

export default CodeSocal;